<template>
  <!-- 罪名详情导航 -->
  <div class="zmdetNav around">
    <div
      class="navitem"
      v-for="(item, index) in navlist"
      :key="index"
      :class="{ navactiv: artph == item.id }"
      @click="tojump(item)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navlist: [
        { name: "首页", id: 0 },
        { name: "概念", id: 1 },
        { name: "构成要素", id: 2 },
        { name: "认定", id: 3 },
        { name: "立案标准", id: 4 },
        { name: "量刑标准", id: 5 },
        { name: "司法解释", id: 6 },
        { name: "法律意见", id: 7 },
        // { name: "案例",  id: 8 },
      ],
    };
  },
  computed: {
    artph() {
      return this.$store.state.jpcol.zuiminart_id;
    },
  },
  methods: {
    tojump(item) {
      console.log("点击了跳转", item);
      this.$store.commit("jpcol/upzmId", item.id);
      this.$emit("changenav");
    },
  },
};
</script>

<style lang="scss" scope>
.zmdetNav {
  padding: 0 22px;
  .navitem {
    padding: 34px 0;
    text-align: center;
    font-size: 18px;
    color: #333333;
    cursor: pointer;
    &.navactiv {
      color: #0465ea;
    }
  }
}
</style>
